module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAG4AAAB/BAMAAAD8/+r2AAAAJFBMVEUAAABCjf9Cjf9Cjf9Cjf9Cjf9Cjf9Cjf9Cjf9Cjf9Cjf9Cjf89oCj2AAAAC3RSTlMATe3zy7Thd1k8EZby/5AAAABmSURBVFjD7dm7EUBQFEXRK5AzowPlKEEV2hCpRSDRnO+IeRFj7Xw1cE7MW115v2oXhxvifvnpIiXuHa6OPsllUXAcx3Ecx3Ecx3Ecx3Ecx3Ecl7rPf+RH+IFbmx6Z9vrVxvJJzUYWuzhBEqJ4XrwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/icon10.png
// module id = Wok1
// module chunks = 1